import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';
import Script from 'react-load-script';
import { get, isEmpty, trim, isEqual } from 'lodash';
import logger from '@adc/logger';
import classnames from 'classnames/bind';
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper';
import { ADDRESS_FIELD_LABEL, GOOGLE_ADDRESS_PARTS, MAP_GOOGLE_PROPS_TO_FORM_PROPS, STREET_NAME_NUMBER_REGEX, } from './constants';
import { getAddressMapFromPlace, mapPropsFromSourceWithMap, } from './utils/index';
export class AddressSuggestionField extends Component {
    static propTypes = {
        compact: PropTypes.bool,
    };
    static defaultProps = {
        compact: false,
    };
    addressInputRef = null;
    state = {
        autocomplete: {},
        isMounted: false,
        selectedAddressText: '',
        selectedAddress: {},
    };
    loadScriptError = () => {
        logger.warn('Could not load Google Places Api.');
    };
    loadScriptSuccess = () => {
        const addressInput = this.addressInputRef;
        const options = this.props.googleAutocompleteOptions || {};
        const autocomplete = new window.google.maps.places.Autocomplete(addressInput.current, {
            types: ['address'],
            ...options,
        });
        autocomplete &&
            autocomplete.addListener('place_changed', this.addressOptionSelected);
        this.setState({ autocomplete });
    };
    addressOptionSelected = () => {
        const { googleAddressParts, mapGooglePropsToFormProps, displayFormattedAddress, } = this.props;
        const onChange = get(this.props, 'onChange', null);
        const place = this.state.autocomplete.getPlace();
        const formattedAddress = place.formatted_address;
        let selectedAddress = getAddressMapFromPlace(place, googleAddressParts);
        selectedAddress = mapPropsFromSourceWithMap(selectedAddress, mapGooglePropsToFormProps);
        const builtSelectedAddressText = `${selectedAddress.street_number || ''} ${selectedAddress.street_name || ''}`;
        const selectedAddressText = displayFormattedAddress
            ? formattedAddress
            : builtSelectedAddressText;
        if (!selectedAddress[mapGooglePropsToFormProps.route] ||
            !selectedAddress[mapGooglePropsToFormProps.street_number]) {
            selectedAddress = Object.assign(selectedAddress, this.streetNameNumberRegex(builtSelectedAddressText));
        }
        Object.assign(selectedAddress, { is_option_selected: true });
        this.setState({ selectedAddress, selectedAddressText });
        onChange &&
            onChange(Object.assign({ selectedAddressText }, selectedAddress));
    };
    streetNameNumberRegex = inputText => {
        const { mapGooglePropsToFormProps } = this.props;
        const streetNameKey = mapGooglePropsToFormProps.route;
        const streetNumberKey = mapGooglePropsToFormProps.street_number;
        const selectedAddress = {};
        const matches = STREET_NAME_NUMBER_REGEX.exec(inputText || '');
        if (matches) {
            ;
            [, selectedAddress[streetNumberKey], selectedAddress[streetNameKey]] =
                matches;
        }
        else {
            selectedAddress[streetNumberKey] = '';
            selectedAddress[streetNameKey] = trim(inputText);
        }
        return selectedAddress;
    };
    onChange = (_, data) => {
        const onChange = get(this.props, 'onChange', null);
        const selectedAddressText = data.value;
        const selectedAddress = this.streetNameNumberRegex(selectedAddressText);
        this.setState({ selectedAddressText, selectedAddress });
        onChange &&
            onChange(Object.assign({ selectedAddressText }, selectedAddress));
    };
    onBlur = (_, data) => {
        const { selectedAddressText, selectedAddress } = this.state;
        const onBlur = get(this.props, 'onBlur', null);
        onBlur && onBlur(Object.assign({ selectedAddressText }, selectedAddress));
    };
    addressInput = input => {
        this.addressInputRef = input && input.inputRef;
    };
    componentWillUnmount() {
        this.addressInputRef = null;
    }
    updateState(value) {
        let nextState = {
            selectedAddress: {},
            selectedAddressText: '',
        };
        if (!isEmpty(value)) {
            const selectedAddressText = value.selectedAddressText || '';
            const selectedAddress = Object.assign(this.streetNameNumberRegex(selectedAddressText), value);
            nextState = {
                selectedAddress,
                selectedAddressText,
            };
        }
        this.setState(nextState);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.value, this.props.value)) {
            this.updateState(nextProps.value);
        }
    }
    componentDidMount() {
        this.setState({ isMounted: true });
        this.updateState(this.props.value);
    }
    render() {
        const { elmId, placeholder, googleApiConfig: { channelName, clientId }, loading, googleAddressParts, mapGooglePropsToFormProps, label, onBlur, onChange, onFocus, value, compact, className, ...rest } = this.props;
        const { isMounted, selectedAddressText } = this.state;
        const newClassName = classnames({
            compact,
            [className]: true,
        });
        return (_jsxs("div", { children: [_jsx(Input, { autoComplete: 'new-address', className: newClassName, ref: this.addressInput, placeholder: placeholder || ADDRESS_FIELD_LABEL, "data-elm-id": `${elmId}_input`, onChange: this.onChange, onBlur: this.onBlur, value: selectedAddressText, ...rest }), isMounted && (_jsx(Script, { url: `https://maps.googleapis.com/maps/api/js?language=en&client=${clientId}&libraries=places&channel=${channelName}`, onError: this.loadScriptError, onLoad: this.loadScriptSuccess }))] }));
    }
}
AddressSuggestionField.propTypes = {
    googleApiConfig: PropTypes.shape({
        channelName: PropTypes.string.isRequired,
        clientId: PropTypes.string.isRequired,
    }),
    googleAutocompleteOptions: PropTypes.object,
    displayFormattedAddress: PropTypes.bool,
    mapGooglePropsToFormProps: PropTypes.object,
    ...commonPropTypes,
};
AddressSuggestionField.defaultProps = {
    googleAddressParts: GOOGLE_ADDRESS_PARTS,
    mapGooglePropsToFormProps: MAP_GOOGLE_PROPS_TO_FORM_PROPS,
};
const AddressSuggestionFieldWrapped = formFieldWrapper((fieldProps, showError) => {
    const { elmId, placeholder, ...rest } = fieldProps;
    return (_jsx(AddressSuggestionField, { placeholder: placeholder, error: showError, elmId: elmId, ...rest }));
});
export default AddressSuggestionFieldWrapped;
export { mapPropsFromSourceWithMap, MAP_GOOGLE_PROPS_TO_FORM_PROPS };
//# sourceMappingURL=index.js.map